export const formatEuro = (value) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: Number.isInteger(value) ? 0 : 2 }).format(value);

export const packagePriceFor = (pkg, trainingType) =>
  pkg?.prices_by_training?.find((p) => p.training_type === trainingType);

const extraInfo = (pkg) =>
  pkg.monthly
    ? `${pkg.credits} Einheiten pro Monat`
    : `${pkg.credits} Einheiten · ${Math.round((pkg.discount || 0) * 100)} % Rabatt`;

export const PackageInfo = ({ pkg }) => {
  const prices = pkg.prices_by_training || [];
  return (
    <div className="space-y-3" data-testid={`package-info-${pkg.id}`}>
      <p className="text-sm text-[#A1A1AA]" data-testid={`package-trainings-${pkg.id}`}>
        Gilt für: {prices.map((p) => p.training_name).join(", ")}
      </p>
      <ul className="space-y-1" data-testid={`package-price-${pkg.id}`}>
        {prices.map((p) => (
          <li key={p.training_type} className="flex items-baseline justify-between gap-3 text-sm">
            <span className="text-white/80">{p.training_name}</span>
            <span className="whitespace-nowrap">
              <span className="text-[#71717A] line-through mr-2">{formatEuro(p.regular_price)}</span>
              <span className="font-semibold text-[#c1ff72]">{formatEuro(p.price)}</span>
              {pkg.monthly && <span className="text-[#71717A] text-xs"> / Monat</span>}
            </span>
          </li>
        ))}
      </ul>
      <p className="text-xs text-[#71717A]">{extraInfo(pkg)}</p>
    </div>
  );
};
